(function () {
  'use strict';

  var root = document.querySelector('[data-b2b-signup]');
  if (!root) return;

  var verifyEndpoint = root.dataset.verifyEndpoint;
  var activateEndpoint = root.dataset.activateEndpoint;
  var resolveEndpoint = root.dataset.resolveEndpoint;
  var applyEndpoint = root.dataset.applyEndpoint;
  var logoutUrl = root.dataset.logoutUrl || '/account/logout';
  // Storefront sign-in URL ending at "return_to=" (snippets/suay-b2b-login-url.liquid).
  var loginPrefix = root.dataset.loginPrefix || '';
  var portalPath = '/pages/b2b-portal';
  var dealerEmailMasked = '';
  var applyCompanyHandle = '';
  // 'program' (?company= resolved) or 'open' (no params); see setApplyMode.
  var applyMode = '';

  // n8n's activate answer is /account/login?email=<email> (CODE_BUILD_SUCCESS in
  // tools/n8n-workflows/build_b2b_signup_workflow.py). New customer accounts drop
  // both `email` and `return_url` there and land on account.suay.com Orders.
  // Rebuild it as the storefront sign-in: login_hint pre-fills the email and
  // return_to lands on the portal. A URL that is already the storefront sign-in
  // (relative or absolute) passes through unchanged. The "Check application
  // status" link after applying is built the same way.
  function portalLoginUrl(redirectUrl) {
    var parsed;
    try {
      parsed = new URL(redirectUrl, window.location.origin);
    } catch (e) {
      return redirectUrl;
    }
    if (!loginPrefix || parsed.pathname === '/customer_authentication/login') return redirectUrl;
    var email = parsed.searchParams.get('login_hint') || parsed.searchParams.get('email') || '';
    var hint = email ? 'login_hint=' + encodeURIComponent(email) + '&' : '';
    return loginPrefix.replace(/return_to=$/, hint + 'return_to=') + encodeURIComponent(portalPath);
  }

  var states = {};
  root.querySelectorAll('[data-state]').forEach(function (el) {
    states[el.dataset.state] = el;
  });

  function showState(name) {
    Object.keys(states).forEach(function (key) {
      states[key].hidden = key !== name;
    });
  }

  function getToken() {
    try {
      var url = new URL(window.location.href);
      return (url.searchParams.get('token') || '').trim();
    } catch (e) {
      return '';
    }
  }

  function getCompanyHandle() {
    try {
      var url = new URL(window.location.href);
      return (url.searchParams.get('company') || '').trim().toLowerCase();
    } catch (e) {
      return '';
    }
  }

  function fillApplyCompany(company) {
    var box = root.querySelector('[data-apply-company]');
    if (!box || !company) return;
    box.hidden = false;
    var logo = root.querySelector('[data-apply-company-logo]');
    var name = root.querySelector('[data-apply-company-name]');
    var suffix = root.querySelector('[data-apply-company-suffix]');
    if (logo && company.logoUrl) {
      logo.src = company.logoUrl;
      logo.alt = company.name || '';
      logo.hidden = false;
    }
    if (name) name.textContent = company.name || '';
    // Per-company member label — Centurion sees "wholesale dealer", Threds
    // sees "wholesale team member", future "Distributors Inc" sees whatever
    // they configure on the metaobject. Falls back to the section's setting
    // (which itself defaults to "wholesale dealer") if the resolve-company
    // response didn't include a memberLabel.
    if (suffix && company.memberLabel) {
      suffix.textContent = 'wholesale ' + company.memberLabel;
    }
  }

  // Program mode: the partner header, every field as before. Open mode: the
  // open header, the business-type fieldset and website enabled (a disabled
  // control is neither validated nor submitted), street + ZIP optional.
  function setApplyMode(mode) {
    applyMode = mode;
    var open = mode === 'open';
    root.querySelectorAll('[data-apply-head]').forEach(function (el) {
      el.hidden = el.dataset.applyHead !== mode;
    });
    root.querySelectorAll('[data-apply-open-only]').forEach(function (el) {
      el.hidden = !open;
    });
    root.querySelectorAll('[data-apply-open-control]').forEach(function (el) {
      el.disabled = !open;
    });
    root.querySelectorAll('[data-apply-program-required]').forEach(function (el) {
      el.required = !open;
    });
    syncBusinessDetail();
  }

  // The brand name (brand_dealer) or description (other) field is shown,
  // enabled and so required only for its business type.
  function syncBusinessDetail() {
    var checked = root.querySelector('input[name="businessType"]:checked');
    var type = applyMode === 'open' && checked ? checked.value : '';
    root.querySelectorAll('[data-business-detail]').forEach(function (wrap) {
      var on = wrap.dataset.businessDetail === type;
      wrap.hidden = !on;
      var input = wrap.querySelector('input');
      if (input) input.disabled = !on;
    });
  }

  // Readable text for the n8n apply webhook's 400s. The form's own validation
  // normally catches these first; anything else shows the server's message.
  function applyErrorText(data) {
    var message = String(data.message || '');
    if (data.code === 'business_type_invalid') return 'Choose the type of business you run.';
    if (data.code === 'field_required' && /^brandName\b/.test(message)) return 'Tell us which brand you are a dealer for.';
    if (data.code === 'field_required' && /^businessTypeOther\b/.test(message)) return 'Tell us what kind of business you run.';
    if (data.code === 'company_handle_invalid' && applyMode === 'open') {
      // The webhook doesn't take open applications yet.
      return 'We couldn’t submit your application right now. Email ' + (root.dataset.supportEmail || 'shop@suay.com') + ' and we’ll set you up.';
    }
    return message || 'Submission failed. Check your details and try again.';
  }

  function showApplyError(text) {
    var msg = root.querySelector('[data-apply-form-message]');
    if (!msg) return;
    msg.textContent = text;
    msg.classList.add('b2b-signup__form-message--error');
    msg.hidden = false;
  }

  function clearApplyError() {
    var msg = root.querySelector('[data-apply-form-message]');
    if (!msg) return;
    msg.hidden = true;
    msg.textContent = '';
    msg.classList.remove('b2b-signup__form-message--error');
  }

  function resolveCompany(handle) {
    showState('loading');
    postJson(resolveEndpoint, { handle: handle })
      .then(function (out) {
        var data = out.json || {};
        if (out.status >= 500) {
          showState('error');
          return;
        }
        if (data.status === 'valid') {
          applyCompanyHandle = data.handle;
          fillApplyCompany(data);
          setApplyMode('program');
          showState('apply');
          return;
        }
        showState('company_invalid');
      })
      .catch(function () {
        showState('error');
      });
  }

  function bindApplyForm() {
    var form = root.querySelector('[data-apply-form]');
    var submit = root.querySelector('[data-apply-submit]');
    if (!form || !submit) return;

    // Stamp the form-render time so the n8n validator can reject submissions
    // that come in faster than a human could plausibly fill the form (~2.5s).
    var startedAtField = form.querySelector('[data-apply-started-at]');
    if (startedAtField) startedAtField.value = String(Date.now());

    form.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'businessType') syncBusinessDetail();
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearApplyError();
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      var fd = new FormData(form);
      var payload = {
        // Honeypot — non-semantic name so browser autofill won't populate it
        // (autocomplete=off is ignored; autofill matches by field name).
        b2b_hp: String(fd.get('b2b_hp') || ''),
        formStartedAt: Number(fd.get('formStartedAt') || 0),
      };
      var keys = ['email', 'firstName', 'lastName', 'phone', 'businessName',
        'address1', 'address2', 'city', 'province', 'zip', 'country', 'message'];
      if (applyMode === 'open') {
        // No companyHandle: n8n's open application (Validate Apply). brandName /
        // businessTypeOther are disabled (so absent) unless their type is chosen.
        keys.push('businessType', 'brandName', 'businessTypeOther', 'website');
      } else {
        payload.companyHandle = applyCompanyHandle;
      }
      keys.forEach(function (k) {
        var v = fd.get(k);
        if (v != null) payload[k] = String(v).trim();
      });

      submit.disabled = true;
      var origLabel = submit.textContent;
      submit.textContent = 'Submitting…';

      postJson(applyEndpoint, payload)
        .then(function (out) {
          var data = out.json || {};
          if (out.status >= 400) {
            showApplyError(applyErrorText(data));
            return;
          }
          if (data.ok && data.status === 'submitted') {
            // "Check application status": sign in as the email just applied
            // with, back to the portal's review screen. The Liquid href (no
            // login_hint) stays if there is no storefront sign-in prefix.
            var status = root.querySelector('[data-status-link]');
            if (status && loginPrefix && payload.email) {
              status.href = portalLoginUrl('/account/login?email=' + encodeURIComponent(payload.email));
            }
            showState('submitted');
            return;
          }
          showApplyError('Unexpected response. Please try again.');
        })
        .catch(function () {
          showApplyError('Network error. Check your connection and try again.');
        })
        .finally(function () {
          submit.disabled = false;
          submit.textContent = origLabel;
        });
    });
  }

  function fillCompany(parentCompany, dealershipName) {
    var box = root.querySelector('[data-company]');
    if (!box) return;
    if (!parentCompany && !dealershipName) {
      box.hidden = true;
      return;
    }
    box.hidden = false;
    var logo = root.querySelector('[data-company-logo]');
    var name = root.querySelector('[data-company-name]');
    var dealer = root.querySelector('[data-dealership-name]');
    var eyebrow = root.querySelector('[data-company-eyebrow]');
    var parentName = (parentCompany && parentCompany.name) || '';
    if (parentCompany && parentCompany.logoUrl && logo) {
      logo.src = parentCompany.logoUrl;
      logo.alt = parentName;
      logo.hidden = false;
    } else if (logo) {
      logo.hidden = true;
    }
    // An open applicant has no parent program: their own business is the name
    // (otherwise the header reads "Activating dealership for" and a blank line).
    if (name) name.textContent = parentName || dealershipName || '';
    if (dealer) {
      dealer.textContent = parentName ? (dealershipName || '') : '';
      dealer.hidden = !dealer.textContent;
    }
    if (eyebrow && !parentName && eyebrow.dataset.ownText) eyebrow.textContent = eyebrow.dataset.ownText;
  }

  function fillForm(data) {
    var emailEl = root.querySelector('[data-email-display]');
    if (emailEl) emailEl.textContent = data.emailMasked || '';

    var prefill = data.prefill || {};
    var setVal = function (name, value) {
      var input = root.querySelector('[name="' + name + '"]');
      if (input != null) input.value = value || '';
    };
    setVal('firstName', prefill.firstName);
    setVal('lastName', prefill.lastName);
    setVal('phone', prefill.phone);
    setVal('address1', prefill.address1);
    setVal('address2', prefill.address2);
    setVal('city', prefill.city);
    setVal('province', prefill.province);
    setVal('zip', prefill.zip);
    setVal('country', prefill.country || 'US');
  }

  function showFormError(text) {
    var msg = root.querySelector('[data-form-message]');
    if (!msg) return;
    msg.textContent = text;
    msg.classList.add('b2b-signup__form-message--error');
    msg.hidden = false;
  }

  function clearFormError() {
    var msg = root.querySelector('[data-form-message]');
    if (!msg) return;
    msg.hidden = true;
    msg.textContent = '';
    msg.classList.remove('b2b-signup__form-message--error');
  }

  function postJson(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (resp) {
      return resp.json().then(function (json) {
        return { status: resp.status, json: json };
      });
    });
  }

  function verify(token) {
    showState('loading');
    postJson(verifyEndpoint, { token: token })
      .then(function (out) {
        var data = out.json || {};
        if (out.status >= 500 || (out.status >= 400 && data.code !== 'token_required' && data.code !== 'token_malformed')) {
          showState('error');
          return;
        }
        var statusName = data.status || (data.code ? 'invalid' : 'invalid');
        if (statusName === 'valid') {
          dealerEmailMasked = data.emailMasked || '';
          fillCompany(data.parentCompany, data.dealershipName);
          fillForm(data);
          showState('valid');
          return;
        }
        if (states[statusName]) {
          showState(statusName);
        } else {
          showState('invalid');
        }
      })
      .catch(function () {
        showState('error');
      });
  }

  function bindForm() {
    var form = root.querySelector('[data-form]');
    var submit = root.querySelector('[data-submit]');
    if (!form || !submit) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearFormError();
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      var token = getToken();
      if (!token) {
        showState('invalid');
        return;
      }

      var fd = new FormData(form);
      var payload = { token: token };
      ['firstName', 'lastName', 'phone', 'address1', 'address2', 'city', 'province', 'zip', 'country'].forEach(function (k) {
        var v = fd.get(k);
        if (v != null) payload[k] = String(v).trim();
      });

      submit.disabled = true;
      var origLabel = submit.textContent;
      submit.textContent = 'Submitting…';

      postJson(activateEndpoint, payload)
        .then(function (out) {
          var data = out.json || {};

          // Terminal-state response (already_activated / expired / etc.) — show that state.
          if (data.status && data.status !== 'activated' && states[data.status]) {
            showState(data.status);
            return;
          }
          // Validation error from server.
          if (out.status >= 400) {
            showFormError(data.message || 'Submission failed. Check your details and try again.');
            return;
          }
          // Success. Wrap the Shopify activation URL in /account/logout so any
          // existing storefront/customer-accounts session gets cleared in the
          // redirect chain. For users without a session, /account/logout is a
          // no-op pass-through. For users signed in elsewhere, it cascades
          // through Shopify's unified Customer Accounts logout, then lands on
          // the activation URL with a clean session.
          if (data.ok && data.redirectUrl) {
            // redirectUrl is /account/login?email=... (rebuilt by portalLoginUrl).
            // Wrap in /account/logout?return_url=<login URL> so any conflicting
            // session is cleared on the way to the login page. /account/logout
            // is a no-op pass-through if there's no session and keeps a
            // same-site return_url.
            var link = root.querySelector('[data-set-password-link]');
            if (link) {
              link.href = logoutUrl + '?return_url=' + encodeURIComponent(portalLoginUrl(data.redirectUrl));
            }
            var emailEl = root.querySelector('[data-email-display-final]');
            if (emailEl) emailEl.textContent = dealerEmailMasked;
            showState('ready');
            return;
          }
          showFormError('Unexpected response from activation service. Please try again.');
        })
        .catch(function () {
          showFormError('Network error. Check your connection and try again.');
        })
        .finally(function () {
          submit.disabled = false;
          submit.textContent = origLabel;
        });
    });
  }

  function bindRetry() {
    var btn = root.querySelector('[data-retry]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var t = getToken();
      if (!t) { showState('invalid'); return; }
      verify(t);
    });
  }

  // ---- Boot ----
  // Three URL modes:
  //   ?token=UUID        → activate flow (existing dealer with invite)
  //   ?company=handle    → program application (partner resolved first)
  //   neither            → open application (anyone; says what business it is)
  // Without the endpoints a mode needs (section not configured) there is no
  // form: "invalid". A ?company= link never falls back to the open form.
  var token = getToken();
  var companyHandle = getCompanyHandle();
  if (token) {
    verify(token);
  } else if (companyHandle && resolveEndpoint && applyEndpoint) {
    resolveCompany(companyHandle);
  } else if (!companyHandle && applyEndpoint) {
    setApplyMode('open');
    showState('apply');
  } else {
    showState('invalid');
  }
  bindForm();
  bindApplyForm();
  bindRetry();
})();
